import { useCallback } from 'react';

import { useTipSharingModal } from './useTipSharingModal';

export function useTriggerTipSharingModal(): () => Promise<void> {
	const openTipSharingModal = useTipSharingModal();

	return useCallback(async () => {
		return openTipSharingModal({}).waitForResult();
	}, [openTipSharingModal]);
}
